<template>
    <div id="DepreciationPreview">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Depreciation Preview</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="web-action-btn btn-groups text-right">
                        <button id="processPermit" v-if="canPostDepreciation && !isReverse" v-on:click.prevent="processDepriciation(false)" class="btn btn-primary"> <i class="fp-process"> </i> Post</button>
                      <button id="processPermit" v-if="canUnprocessDepreciation && isReverse" v-on:click.prevent="processDepriciation(true)" class="btn btn-primary"> <i class="fp-process"> </i> Unpost</button>
                        <button type="submit" class="btn btn-tertiary" v-on:click.prevent="backToList">
                            <i class="fp-back"> </i> Back
                        </button>
                    </div>
                    <div class="mobile-action-btn elipse-btn">
                        <button id="processPermit" v-if="canPostDepreciation && !isReverse" v-on:click.prevent="processDepriciation(false)" class="btn btn-secondary"> <i class="fp-process"> </i> Post</button>
                      <button id="processPermit" v-if="canUnprocessDepreciation && isReverse" v-on:click.prevent="processDepriciation(true)" class="btn btn-secondary"> <i class="fp-process"> </i> Unpost</button>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content dep-schedule-list">
                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <data-table-filter-config :moduleName="'DepreciationPreviewList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <p v-if="batchProcess" class="alert-success p-2">{{batch_msg}}</p>
                        <p v-if="batchError" class="alert-danger p-2" id="processErrorBatchMsg">{{batchErrorMsg}}<button type="button" class="close close-alert" v-on:click="batchError = false;batchErrorMsg = ''">×</button></p>
                        <section class="bg-white data-table">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'DepreciationPreviewList'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                    ref="listDepreciationPreview"
                                    mode="remote"
                                    title="DepreciationPreview"
                                    @on-page-change="onPageChange"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        dropdownAllowAll: false,
                                    }"
                                    >
                                     <!-- <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'" class='text-center'>
                                                <template>
                                                    <router-link title="Update Schedule" class="fp-edit" v-bind:to="{name: 'DepriciationEdit',params:{id:props.row.id}}"></router-link>
                                                </template>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template> -->
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";
import EventBus from ".././event-bus";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
import moment from 'moment';

let msgServer
    export default {
        name: "DepreciationPreviewList",
        metaInfo: {
            // title will be injected into parent titleTemplate
            title: "DepreciationPreview List | " +process.env.COPYRIGHT_NAME
        },
        mixins:[commonMixins,dataTableMixins],

        data: () => ({
            pageTitle: "Depreciation Preview List",
            depreciation_value: true,
            hideButton:false,
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: '#Unit',
                    field: 'unit_no',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit No", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Transaction Date',
                    field: 'transaction_date',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"date",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Transaction Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Depreciation Amount',
                    field: 'depriciation_amount',
                    fpFieldType:"integer",
                    filterable: true,
                    type:'number',
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Capital Amount", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Depreciation Rate',
                    field: 'depriciation_rate',
                    fpFieldType:"integer",
                    filterable: true,
                    type:'number',
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Depreciation Rate", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Net Book Value',
                    field: 'net_book_value',
                    fpFieldType:"integer",
                    filterable: true,
                    type:'number',
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Net Book Value", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Accumulated Depreciation',
                    field: 'accumulated_depriciation',
                    fpFieldType:"integer",
                    filterable: true,
                    hidden:false,
                    type:'number',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Accumulated Depreciation", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Pool View',
                    field: 'pool',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "PoolView", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Posted',
                    field: 'posted',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Posted", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Yes','No'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Status',
                    field: 'discard',
                    fpFieldType:"option",
                    filterable: false,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Posted", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Yes','No'],
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
            ],
            rows: [],
            totalRecords: 0,
            serverParams: {
                columnFilters: {},
                sort: {
                    field: 'id',
                    type: 'desc',
                },
                page: 1,
                perPage: 10
            },
            loading:false,
            pageKey:"_depreciation_schedule_list_",
            action:'list',
            effective_date:'',
            vehicle_pool_id:'',
            location_id:'',
            optionsDate: {
                format: 'MM/DD/YYYY',
                useCurrent: false,
            },
            canPostDepreciation:false,
            canUnprocessDepreciation:false,
            dateArr:[],
            batchProcess:false,
            batchErrorMsg:'',
            batchError:false,
            batch_msg:'',
            batchNum:'',
            isReverse:false,
            batchId:'',
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_depreciation_schedule') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'post_asset_depreciation') {
                            self.canPostDepreciation = true;
                        }
                      if (permissions[i].name == 'unpost_gl') {
                        self.canUnprocessDepreciation = true;
                      }
                    }
                }

            }

        },
        created: function() {

        },
        beforeDestroy() {
        // Make sure to close the connection with the events server
        // when the component is destroyed, or we'll have ghost connections!
            msgServer.close();
        },
        mounted: function() {
            var self = this;
            //self.loadList();

            //when component list directly call from url instead of in view page than call permission request
            self.getPermissions();

            var webloc = window.location.href;

            var decodeStr = "";

            if ( this.$route.query.data != '' && this.$route.query.data != undefined ) {

                decodeStr = atob(this.$route.query.data)

            }

            var url = new URL(webloc+"?"+decodeStr);
            console.log(url);
            self.effective_date = url.searchParams.get("effective_date");
            self.vehicle_pool_id = url.searchParams.get("pool_id");
            self.location_id = url.searchParams.get("loc_id");
            self.isReverse = url.searchParams.get("isReverse");
            self.batchId = url.searchParams.get("batchId")

        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listDepreciationSchedule.unselectAllInternal();
            },
            checkBatchStatus:function(){
                var self =  this;

                this.$sse(process.env.ROOT_API + '/check/batch-status/'+self.batchId, { format: 'json' }) // or { format: 'plain' }
                .then(sse => {
                    // Store SSE object at a higher scope
                    msgServer = sse;

                    // Listen for messages without a specified event
                    sse.subscribe('', data => {
                        if ( data.status == "1") {
                            self.batch_msg = 'Depreciation Posted successfully';
                            setTimeout(function(){
                                self.batch_msg = '';
                                self.batchProcess = false;
                                self.$router.push('/depreciation-schedule/list');
                            },4000);
                            // self.loadList();
                            sse.close();
                        }else if (data.status == "2") {

                            self.batchProcess = false;
                            self.batch_msg = 'Depreciation Not Posted';
                            self.batchError = true;
                            self.batchErrorMsg = data.message;
                            sse.close();
                        }
                    });

                })
                .catch(err => {
                    // When this error is caught, it means the initial connection to the
                    // events server failed.  No automatic attempts to reconnect will be made.
                    console.error('Failed to connect to server', err);
                });

            },

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            backToList: function(){
                var self = this;

                self.$router.push('/depreciation-schedule/list');
            },

            loadList() {
                var self = this;
                self.loading = true;
                 var selectedRows = [];

                //because on first load list not initialize
                // var data = this.$refs['listDepreciationPreview'].selectedRows;
                // for ( var i = 0; i < data.length; i++ ) {
                //     selectedRows.push(this.$refs['listDepreciationPreview'].selectedRows[i].id)
                // }

                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    action: self.action,
                    effective_date:self.effective_date,
                    location_id:self.location_id,
                    vehicle_pool_id:self.vehicle_pool_id,
                    isReverse: self.isReverse,
                    batchId: self.batchId,
                    // selectedRows:selectedRows

                };
                self.firstLoad = 1;

                $.ajax({
                    url: process.env.ROOT_API + "/depreciation-preview/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'asset-dep-preview-list')

                    }
                });
            },

            processDepriciation: function(isUnprocess){
                var self = this;
                // self.effective_date_error_msg = '';
                var vehicle_pool_id = '';
                var location_id = '';
                // if ( self.effective_date == ''){
                //     self.effective_date_error_msg = 'Date Required';
                //     return;
                // }

                if ( self.vehicle_pool_id != null && self.vehicle_pool_id != undefined){
                    vehicle_pool_id = self.vehicle_pool_id;
                }
                if ( self.location_id != null && self.location_id != undefined){
                    location_id = self.location_id;
                }

                if (self.rows.length < 1) {
                    self.$swal('','There are no records to process','info');
                    return;
                }

                if (isUnprocess){
                  var confirmMessage = "Are you sure to unpost the depreciation ?";
                }else{
                  var confirmMessage = "Are you sure to post depreciation ?";
                }
                $("#addProcessDepriciationBtn").val("Processing ...");
                $("#addProcessDepriciationBtn").prop("disabled", true);

                if (confirm(confirmMessage)){

                    $.ajax({
                        url: process.env.ROOT_API + "/depriciation-schedule/post",
                        type: "POST",
                        data: {
                            // fields:this.$refs['listPermitTable'].selectedRows,
                            page: self.serverParams.page,
                            perPage: self.serverParams.perPage,
                            filters: self.serverParams.columnFilters,
                            sort: self.serverParams.sort,
                            effective_date:self.effective_date,
                            pool_id:vehicle_pool_id,
                            location_id:location_id,
                            is_reversal:isUnprocess,
                            batchId: self.batchId,
                        },
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            if (data.status == "success") {
                                self.batchId = data.batch_id;
                                self.batchNum = data.batch;
                                self.batchProcess = true;
                                self.batch_msg = 'Current batch '+ self.batchNum + ' is processing for posting depreciation';
                                self.checkBatchStatus();
                                // self.loadList();

                                // setTimeout(function () {
                                // $(".alert-success").removeClass("show");
                                //     $(".alert-success").addClass("hide");
                                // }, 10000);

                                if (data.code == '200') {
                                    $("#processModal").modal('hide');
                                    // self.$router.push('/depreciation-schedule/list');
                                }
                                $("#addProcessDepriciationBtn").val("Process");
                                $("#addProcessDepriciationBtn").prop("disabled", false);
                            }else{
                                self.$swal('',data.content,'info');
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            $("#addProcessDepriciationBtn").val("Process");
                            $("#addProcessDepriciationBtn").prop("disabled", false);
                            self.generateStatusCodeMessage(jqXHR,true,'permit-import-error')

                        }
                    });
                }

            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/asset/DepreciationPreview.vue